import React from "react";
import ServiceItems from "../Data/Serviceitems";
import "./Showsub2.css";
import { Link } from "react-router-dom";

const MediaServiceDropdown = ({ handleClose }) => {
  return (
    <ul className="drop_down_cont_media">
      {ServiceItems.map((item, index) => (
        <li key={index}>
          <Link
            className="drop_down_cont_media"
            to={item.path}
            onClick={handleClose}
          >
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default MediaServiceDropdown;